<!--
 * @Descripttion: TabBar Layout
 * @FilePath: /mall-wap-vue/src/layout/tabbar.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:57:10
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-09-25 00:24:39
-->
<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <TabBar />
  </div>
</template>

<script>
const TabBar = () => import("@/components/TabBar").then(m => m.default || m);

export default {
  components: { TabBar }
};
</script>
